import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useContestantByCode } from '../hooks/useContestantByCode';
import { useVoteStore } from '../stores/voteStore';
import { LoadingSpinner } from '../components/shared/LoadingSpinner';
import { ErrorDisplay } from '../components/shared/ErrorDisplay';

export const VoteRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const { contestant, isLoading, error } = useContestantByCode(code);
  const openVoteModal = useVoteStore((state) => state.openModal);

  useEffect(() => {
    if (contestant) {
      openVoteModal(contestant.id);
      navigate(`/c/${contestant.contest_id}`, { replace: true });
    }
  }, [contestant, navigate, openVoteModal]);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorDisplay error={error} />;

  return null;
};